import { mantenimientoWhyChoose } from "@/mocks/serviceMantenimientoData";

export default function MantenimientoWhyChoose() {
  return (
    <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="reveal relative h-[320px] md:h-[460px] rounded-lg overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20HVAC%20technician%20team%20in%20matching%20blue%20uniforms%20inspecting%20commercial%20air%20conditioning%20system%20inside%20modern%20facility%2C%20checking%20gauges%20and%20clipboard%2C%20teamwork%2C%20clean%20industrial%20interior%2C%20warm%20professional%20lighting%2C%20editorial%20photography%2C%20teal%20blue%20accent%20tones%2C%20high%20detail&width=700&height=900&seq=mantenimiento-whychoose-1&orientation=portrait"
              alt="Equipo de técnicos certificados de SERIN"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="reveal">
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0087a4] mb-3 block">
              Por qu&eacute; elegirnos
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-6 leading-tight">
              Confianza y garant&iacute;a en cada visita
            </h2>

            <ul className="space-y-4">
              {mantenimientoWhyChoose.map((item, i) => (
                <li
                  key={item.title}
                  className="reveal flex items-start gap-3"
                  style={{ transitionDelay: `${i * 70}ms` }}
                >
                  <div className="w-8 h-8 rounded-lg bg-[#0087a4]/10 text-[#0087a4] flex items-center justify-center shrink-0">
                    <i className={`${item.icon} text-base`} />
                  </div>
                  <span className="text-foreground-700 text-sm md:text-base leading-relaxed">
                    {item.title}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}